/* FamilyStore.io Option 6 "Family Market" - header behaviour.
   1. Live cart progress toward the order minimum: every [data-fs6-cart] root (desktop pill = #cart-icon-bubble,
      mobile progress pill) is repainted from /cart.js on Sense's pubsub cartUpdate, on the
      'fs6:cart-updated' window event (detail.cart may carry a /cart.js payload) and on back/forward cache restores.
   2. Department-scoped search: a chosen department scopes the query with q=product_type:"<Department>" <terms>,
      or opens that department's collection when no terms are typed.
   3. --header-height kept current (sticky-header only sets it on load / at 990px), for scroll-padding-top.
   4. Menu drawer focus containment: Sense's trapFocus() takes its last element from a list that includes links in
      collapsed <details>, so at a department (level-2) panel Tab walked out of the drawer onto page content hidden
      behind it. Tab / Shift+Tab now wrap within the deepest open panel, counting only rendered controls, and Escape
      closes the drawer even if focus is outside it.
   5. Horizontal scrollers (product rails, shelf and quick-find chips): a focused card or chip that is only partly
      visible is scrolled fully into view (Chrome treats a partly visible "peek" item as already visible). */
(function () {
  'use strict';
  if (window.fs6HeaderReady) return;
  window.fs6HeaderReady = true;

  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var pending = null;

  function money(cents, currency) {
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(whole ? 0 : 2);
    }
  }

  function each(root, selector, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), fn);
  }

  function paint(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    each(document, '[data-fs6-cart]', function (root) {
      var min = parseInt(root.getAttribute('data-fs6-min'), 10);
      if (!(min > 0)) min = 10000;
      var total = cart.total_price;
      var remaining = Math.max(min - total, 0);
      var pct = Math.min(100, Math.floor((total * 100) / min));
      var count = cart.item_count || 0;
      var state = root.querySelector('[data-fs6-cart-state]');
      if (state) {
        state.classList.toggle('is-met', remaining === 0);
        state.classList.toggle('is-empty', count === 0);
      }
      each(root, '[data-fs6-cart-total]', function (n) { n.textContent = money(total, cart.currency); });
      each(root, '[data-fs6-cart-remaining]', function (n) { n.textContent = money(remaining, cart.currency); });
      each(root, '[data-fs6-cart-bar]', function (n) { n.style.width = pct + '%'; });
      each(root, '[data-fs6-cart-count]', function (n) {
        n.textContent = count < 100 ? String(count) : '99+';
        n.hidden = count === 0;
      });
      each(root, '[data-fs6-cart-count-label]', function (n) {
        var one = n.getAttribute('data-one');
        var other = n.getAttribute('data-other');
        if (one && other) n.textContent = count === 1 ? one : other.replace('[count]', String(count));
      });
    });
  }

  function refresh() {
    if (pending && pending.abort) pending.abort();
    pending = window.AbortController ? new AbortController() : null;
    fetch(cartUrl + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: pending ? pending.signal : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(paint)
      .catch(function () {});
  }

  window.addEventListener('fs6:cart-updated', function (event) {
    var cart = event && event.detail && event.detail.cart;
    if (cart && typeof cart.total_price === 'number' && typeof cart.item_count === 'number') paint(cart);
    else refresh();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    // Sense publishes cartUpdate before it re-renders #cart-icon-bubble; fetching /cart.js afterwards keeps
    // the mobile pill (not section-rendered) and a custom minimum in step.
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 0); });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  /* Department-scoped search */
  function bindSearch(scope) {
    each(scope || document, 'form[data-fs6-search]', function (form) {
      if (form.hasAttribute('data-fs6-bound')) return;
      form.setAttribute('data-fs6-bound', '');
      var select = form.querySelector('[data-fs6-search-dept]');
      var input = form.querySelector('input[name="q"]');
      if (!select || !input) return;
      form.addEventListener('submit', function (event) {
        var host = form.closest('predictive-search');
        // Sense's predictive search follows a highlighted suggestion itself.
        if (host && host.querySelector('[aria-selected="true"] a')) return;
        // The picker is hidden on phones and mid-size screens: search everything there.
        if (select.selectedIndex < 1 || !select.offsetParent) return;
        var option = select.options[select.selectedIndex];
        var terms = input.value.trim();
        event.preventDefault();
        if (!terms) {
          window.location.href = option.getAttribute('data-url') || form.getAttribute('action');
          return;
        }
        var params = new URLSearchParams();
        params.set('q', 'product_type:"' + option.value.replace(/"/g, '') + '" ' + terms);
        params.set('type', 'product');
        params.set('options[prefix]', 'last');
        window.location.href = form.getAttribute('action') + '?' + params.toString();
      });
    });
  }
  bindSearch(document);
  // Theme editor re-renders the header section in place.
  document.addEventListener('shopify:section:load', function (event) { bindSearch(event.target); });

  /* 3. Header height for scroll-padding-top (see sections/header.liquid). */
  var headerSection = document.querySelector('.section-header');
  function setHeaderHeight() {
    headerSection = document.querySelector('.section-header');
    if (headerSection) document.documentElement.style.setProperty('--header-height', headerSection.offsetHeight + 'px');
  }
  if (headerSection && 'ResizeObserver' in window) {
    new ResizeObserver(setHeaderHeight).observe(headerSection);
  } else {
    window.addEventListener('resize', setHeaderHeight);
  }

  /* 4. Menu drawer focus containment. */
  var FOCUSABLE = 'summary, a[href], button:enabled, input:not([type="hidden"]):enabled, select:enabled, textarea:enabled, [tabindex]:not([tabindex^="-"])';

  function rendered(el, scope) {
    if (!el.getClientRects().length) return false;
    var cs = getComputedStyle(el);
    if (cs.visibility === 'hidden' || cs.display === 'none') return false;
    // Inside a closed <details> only its own summary is reachable.
    var d = el.closest('details');
    while (d && scope.contains(d)) {
      if (!d.open && !(el.tagName === 'SUMMARY' && el.parentElement === d)) return false;
      d = d.parentElement && d.parentElement.closest('details');
    }
    return true;
  }

  function drawerParts() {
    var drawer = document.querySelector('header-drawer');
    var main = drawer && drawer.querySelector('details');
    if (!main || !main.open) return null;
    // Deepest open panel (level 3 is nested inside level 2); level 1 is the whole drawer including its toggle.
    var panels = main.querySelectorAll('details[open].menu-opening > .menu-drawer__submenu');
    return { drawer: drawer, main: main, scope: panels.length ? panels[panels.length - 1] : main };
  }

  window.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
    var parts = drawerParts();
    if (!parts) return;
    var list = Array.prototype.filter.call(parts.scope.querySelectorAll(FOCUSABLE), function (el) {
      return rendered(el, parts.scope);
    });
    if (!list.length) return;
    var i = list.indexOf(document.activeElement);
    var target = null;
    if (event.shiftKey && i <= 0) target = list[list.length - 1];
    else if (!event.shiftKey && (i === -1 || i === list.length - 1)) target = list[0];
    if (!target) return;
    event.preventDefault();
    event.stopPropagation(); // Sense's own trapFocus keydown (document, bubble) must not move focus again.
    target.focus();
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    var parts = drawerParts();
    if (!parts || parts.drawer.contains(event.target)) return; // inside, Sense closes the open panel itself
    var summary = parts.main.querySelector('summary');
    if (typeof parts.drawer.closeMenuDrawer === 'function') parts.drawer.closeMenuDrawer(event, summary);
  });

  /* 5. Keep a focused item of a horizontal scroller fully in view. */
  var HSCROLL = '.fs6-rail__track, .fs6-depts__shelf-list, .fs6-hero__chips, [data-fs6-hscroll]';
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function reveal(track, item) {
    if (track.scrollWidth - track.clientWidth < 2) return;
    var cs = getComputedStyle(track);
    var padL = parseFloat(cs.scrollPaddingLeft) || 0;
    var padR = parseFloat(cs.scrollPaddingRight) || 0;
    var tr = track.getBoundingClientRect();
    var ir = item.getBoundingClientRect();
    var left = tr.left + padL;
    var right = tr.right - padR;
    if (ir.left >= left - 1 && ir.right <= right + 1) return;
    var current = track.scrollLeft;
    var dest;
    if (ir.left < left || ir.width > right - left) {
      dest = current + (ir.left - left);
    } else {
      // Scroll just enough, then round up to the next item start so scroll-snap cannot pull it back out of view.
      var need = current + (ir.right - right);
      dest = current + (ir.left - left);
      Array.prototype.forEach.call(track.children, function (child) {
        var pos = current + (child.getBoundingClientRect().left - left);
        if (pos >= need - 1 && pos < dest) dest = pos;
      });
    }
    track.scrollTo({ left: Math.max(0, dest), behavior: reduce.matches ? 'auto' : 'smooth' });
  }

  document.addEventListener('focusin', function (event) {
    var el = event.target;
    if (!el || !el.closest) return;
    var track = el.closest(HSCROLL);
    if (!track || track === el) return;
    var item = el;
    while (item.parentElement && item.parentElement !== track) item = item.parentElement;
    // After the browser's own focus scrolling has run.
    requestAnimationFrame(function () { reveal(track, item); });
  });
})();
